import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { find } from 'lodash';
import { Observable } from 'rxjs/internal/Observable';
import { Store } from '@ngrx/store';
import { AppState } from '../../../projects/brokerage-eapp/src/app/app-reducer';
import { first } from 'rxjs/operators';


@Component({
	selector: 'error-messages',
	templateUrl: './error-messages.component.html'
})

export class ErrorMessagesComponent {
	@Input() form: any;
	@Input() field: string;
	@Input() skipFeedback: boolean;
	errorMessages: Array<any>;
	fullName: string;
	appState$: Observable<any>;
	invalidCharactersMsg = 'Invalid characters.';

	constructor(
		private store: Store<AppState>,
		public router: Router
	) {
		this.skipFeedback = false;
		this.appState$ = this.store.select('sections');
		this.appState$.pipe(first()).subscribe((state: any) => {
			if (state && state['content'] && state['content']['SECTIONAProposedInsured']) {
				const middleName =state['content']['SECTIONAProposedInsured']['Name']['MiddleName'] ? state['content']['SECTIONAProposedInsured']['Name']['MiddleName'].toString().trim() : null;
				const firstName = state['content']['SECTIONAProposedInsured']['Name']['FirstName'] ? state['content']['SECTIONAProposedInsured']['Name']['FirstName'].toString().trim() : null;
				const lastName =  state['content']['SECTIONAProposedInsured']['Name']['LastName'] ? state['content']['SECTIONAProposedInsured']['Name']['LastName'].toString().trim() : null;
				this.fullName = firstName + ' ' + (middleName ? middleName + ' ' : '') + lastName;
			}
		});
		this.errorMessages = [
			{
				type: 'invalidState',
				message: 'JH eApp is not available for this state. Please use a drop ticket or traditional paper application for your submission. Thank you.'
			},
			{
				type: 'required', // note, this message is suppressed in the template for non-linear navigation
				message: 'Required field.'
			},
			{
				type: 'maxlength',
				message: 'Maximum character length.'
			},
			{
				type: 'minlength',
				message: 'Minimum character length.'
			},
			{
				type: 'min',
				message: 'Below minimum value.'
			},
			{
				type: 'max',
				message: 'Exceeds maximum value.'
			},
			{
				type: 'invalidName',
				message: this.invalidCharactersMsg
			},
			{
				type: 'invalidZip',
				message: this.invalidCharactersMsg
			},
			{
				type: 'invalidStreet1',
				message: this.invalidCharactersMsg
			},
			{
				type: 'invalidStreet2',
				message: this.invalidCharactersMsg
			},
			{
				type: 'invalidPhone',
				message: 'Invalid phone number.'
			},
			{
				type: 'invalidEmail',
				message: 'Invalid email.'
			},
			{
				type: 'invalidAlpha',
				message: 'Invalid location.'
			},
			{
				type: 'isValidOccupation',
				message: 'An invalid occupation has been entered. If you do not see your occupation in the drop down list, ' +
						'please select \'Other\' and type your occupation in the input field.'
			},
			{
				type: 'invalidSS',
				message: 'Invalid social security number.'
			},
			{
				type: 'invalidTID',
				message: 'Invalid Tax ID number.'
			},
			{
				type: 'invalidDate',
				message: 'Invalid date.'
			},
			{
				type: 'invalidDateRange',
				message: 'Date is out of range.'
			},
			{
				type: 'requiredSelf',
				message: `If you are not the payor for this policy, you can not continue with the online application.
				You may manually complete a Pre-Authorized Payment Plan form to submit with this application.`
			},
			{
				type: 'invalidWeightAmount',
				message: `Use only when change is greater than 10 lbs.`
			},
			{
				type: 'invalidFeet',
				message: `Invalid feet.`
			},
			{
				type: 'invalidInches',
				message: `Invalid inches.`
			},
			{
				type: 'invalidWeight',
				message: `Invalid weight.`
			},
			{
				type: 'invalidPercentage',
				message: 'Invalid Percentage.'
			},
			{
				type: 'invalidAllocation',
				message: 'Total Percentage must equal 100%.'
			},
			{
				type: 'invalidDl',
				message: `Invalid driver's license number.`
			},
			{
				type: 'invalidAge',
				message: 'Valid age is 18 to 79.'
			},
			{
				type: 'invalidMinAge',
				message: 'Owner must be age 20 or older.'
			},
			{
				type: 'ineligibleTerm30',
				message: 'Valid age for this term is 20 to 50.'
			},
			{
				type: 'ineligibleTerm20',
				message: 'Valid age for this term is 20 to 60.'
			},
			{
				type: 'ineligibleTerm15',
				message: 'Valid age for this term is 20 to 65.'
			},
			{
				type: 'ineligibleTerm10',
				message: 'Valid age for this term is 20 to 70.'
			},
			{
				type: 'invalidNumber',
				message: 'Invalid number.'
			},
			{
				type: 'invalidBankRoutingNumber',
				message: 'Invalid routing number.'
			},
			{
				type: 'invalidCreditCardFormat',
				message: 'Invalid credit card number.'
			},
			{
				type: 'invalidBankAccountNumberMatch',
				message: 'Bank number does not match.'
			},
			{
				type: 'invalidCreditCardDate',
				message: 'Invalid expiration date.'
			},
            {
                type: 'invalidTermAmount',
                message: 'Invalid amount.'
            },
            {
                type: 'invalidSupplementAmount',
                message: 'This amount cannot be higher than Base Face Amount.'
            },
			{
				type: 'invalidDateRage',
				message: 'Date is out of range.'
			},
			{
				type: 'servicingAgentMaxLimit',
				message: 'There must be only one servicing agent.'
			},
			{
				type: 'deadEnd',
				message: 'Due to your response, this application may not be entered using the online eApp utility. Please utilize a different method to submit this application.'
			},
            {
                type: 'invalidExistingPolicy',
                message: 'This information conflicts with an answer given in the Existing Insurance section on the previous page regarding replacements.  Please correct the question containing the conflicting information in order to proceed.'
			},
			{
				type: 'wrongBillingMethod',
				message: 'In order to apply for Temporary Insurance through this e-application process, you will need to change your selected billing method to Pre-Authorized Payment Plan. Please return to the Coverage Details section to make this change. If you do not wish to change your billing method, change your answer to the above question to "No" in order to proceed through the e-application without Temporary Insurance.'
			},
            {
                type: 'InvalidExistingInsuranceAnnuities',
                message: 'You have provided conflicting responses to the above two existing life insurance questions. In order to complete this application in good order, please change your response to one of the above two questions before proceeding through the e-application'
			},
			{
				type: 'InvalidNumber',
				message: 'Number is out of range'
			},
            {
                type: 'invalidMaxAge',
                message: 'Invalid Age'
            },
            {
                type: 'invalidYears',
                message: 'Invalid year. Max is 100.'
            },
            {
                type: 'invalidThreeDigit',
                message: 'Max three digit is accepted.'
            },
            {
                type: 'InvalidPastCurrentYear',
                message: 'Invalid Year'
            },
            {
                type: 'servicingAgentMinRequired',
                message: 'At least one servicing agent is required'
            },
            {
                type: 'minOneSelection',
                message: 'Select at least one option.'
            },
            {
                type: 'invalidIncreaseByPercentage',
                message: 'Increase by is allowed upto 25 %'
			},
			{
				type: 'notOneHundred',
				message: 'Reminder: please ensure that the total percentage across all accounts above equals 100%'
			},
			{
				type: 'notMatchMonthlyTransfer',
				message: 'Reminder: please ensure that the total above equals the Monthly Transfer Dollar Amount'
			}
		];
	}

	// utility
	getErrorMessage(key: string) {
		if (this.form.get(this.field).errors[key].message){
			return this.form.get(this.field).errors[key].message;
		}

		const match = find(this.errorMessages, {type: key});

		return match ? match.message : "Invalid input format.";
	}
}
